import { Component, OnInit } from '@angular/core';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { ToastrService } from 'ngx-toastr';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { UtilsModule } from 'src/app/common/utils/utils.module';

@Component({
  selector: 'app-trigger-computations',
  templateUrl: './trigger-computations.component.html',
  styleUrls: ['./trigger-computations.component.css']
})
export class TriggerComputationsComponent implements OnInit {
  tabledata;
  regionList : [];
  selectedistrict :any;
  filterOptions :object = {year:'', group :[], indicatorarray: '', themearray: ''};
  yearDropDownList;
  assessmentYear;
  stateDropDownList = [];
  region;
  datasubmit = 'statewise';
  checkall;
  activeSpinner : boolean;
  triggercomputedlist : object = {"ay" :'',"montharray":''}
  urlparams: object;
  usertab: any;
  userdetails: any;
  monthList:any = [
    { key: '04' ,value: 'April'},
    { key: '05' ,value:'May'},
    { key: '06' ,value: 'June'},
    { key: '07' ,value:'July'},
    { key: '08' ,value: 'August'},
    { key: '09' ,value:'September'},
    { key: '10' ,value: 'October'},
    { key: '11' ,value:'November'},
    { key: '12' ,value: 'December'},
    { key: '01' ,value:'January'},
    { key: '02' ,value: 'February'},
    { key: '03' ,value:'March'},
  ];
  monthsList: any;
  stateuuid = null;
  showdistdropdown: any;
  districtflag: boolean;
  distuuid: any;
  selectedstate : any;
  DistrictList = []
  activespineer: boolean;
  dropdownsState: any[];
  filterDropDownList : object = {AssesmentYearList:[], GroupList:[], StateList:[], IndicatorList:[], ThemeList:[],Statedropdown:[],DistrictList:[]};
  statearrays: any[];
  statefunction: boolean;
  groupselected: any;
  // selectedstate: any;
  Urlparams: any;
  yearassesmentlist: any;
  stateArrayList: any[];
  statelists: any[];
  filterdistrict: any;
  showdistdrop: boolean;
  selectedId: any;
  assesmentlist: any;
  constructor(private submitdataservice  : SubmitdataService, private logsrv : AuthloginService,private route: ActivatedRoute,  public utils : UtilsModule,
    private toastr : ToastrService, private constants : ConstantsModule,  private router: Router) { }

  ngOnInit() { 
    this.getdynamicYears();
    // this.yearassesmentlist = this.submitdataservice.getassesmentYear();
    // this.triggercomputedlist['ay'] = this.yearassesmentlist[this.yearassesmentlist.length-1] 
    this.urlparams = this.submitdataservice.getWritableObject(this.route.snapshot.params)
    this.usertab = this.urlparams['component'];
    this.monthsList = this.monthList;
    this.userdetails = this.logsrv.checkloginstatus();
    // this.yearDropDownList = this.submitdataservice.getassesmentYear();
    // this.assessmentYear = this.yearDropDownList[this.yearDropDownList.length-1];
    // this.getRegionList();
    // this.getLocationList();
    this.getstateslist();
  //  this. getassesmentunit();
  //  this.getLocationListREgion();
   this.setCurrentMonthDefault();
  }
  public AddDefaultUrlParams(){
    
    this.Urlparams = this.utils.getWritableObject(this.route.snapshot.params);

    // this.triggercomputedlist['ay'] = this.submitdataservice.getassesmentYear().slice(1)
    this.submitdataservice.getYearsToDisplay(this.submitdataservice.yearsPayload).subscribe(data=>{
      this.triggercomputedlist['ay'] = data['data'].slice(1);
    });
    this.setyear(this.Urlparams['assesmentyear']);
    this.setgroup(this.Urlparams['group']);
    // this.setComponent(this.Urlparams['component']);
    let urlParams = {}
    urlParams = Object.assign(this.Urlparams);

    this.router.navigate(['/mis', urlParams]);

  }
  getdynamicYears(){
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }    
    this.submitdataservice.getYearsToDisplay(this.submitdataservice.yearsPayload).subscribe(data=>{
      this.assesmentlist = data['data'];
    });    this.triggercomputedlist['ay'] = dropDownYear;
  }
  private setyear(year){    
    this.filterOptions['assesmentyear'] = year || this.filterDropDownList['AssesmentYearList'][this.filterDropDownList['AssesmentYearList'].length-1]
  }
  private setgroup(group){

    let grouparray = [];
      this.filterOptions['grouparray'] =  group || [ { "item_id": "20d5931b-d962-4b4f-9fde-08d9db3db3e8", "item_text": "NON HIMALAYAN" } ]
       
         
  }
  setCurrentMonthDefault(){
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj =>{
      if(parseInt(monthObj['key'])  == currentmonth + 1){
        currentmonthObj = monthObj;
      }
    });
    this.triggercomputedlist['montharray'] = currentmonthObj['key'];
  }
  getRegionList(){
    this.activeSpinner = true;
    let params = {
      pType: "COUNTRY",
      cType: "REGION",
      component: "",
      src: ""
    }
    this.submitdataservice.getLocationList(params).subscribe(data =>{
      this.regionList = data['INDIA'];
      if(this.regionList.length > 0){
        this.regionList.forEach(list =>{
          if(list['name'] == "NON HIMALAYAN")
            this.region = list['uuid'];
        })
        // this.getTabledata();
      }
    })
  }
 
  async getassesmentunit(){
   let options = {
     "st" : (this.stateuuid != 'null' ? this.stateuuid : null),
     "userId" : this.userdetails['loggedUserData']['userProfile']['userId']
   }
  this.showdistdropdown = await this.submitdataservice.getAssesmentData(options);
  if(this.showdistdropdown == false){
    this.districtflag = false
  }
  this.activeSpinner = false;
  if(this.showdistdropdown){
    this.getLocationForDistrict();
  }
}
getstateslist(){
  let postdata = {};
  this.stateArrayList = [];
  this.statelists = [];
  postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
  postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
  postdata["component"] = "";
  postdata["src"] = "";
  this.submitdataservice.getLocationList(postdata).subscribe(data =>{
    if(data){
       this.statelists = [];
         Object.keys(data).forEach(key =>{
        data[key].forEach(statelist => {
          this.stateArrayList.push(statelist);
          this.stateArrayList.sort((a, b) => (a.name > b.name) ? 1 : -1);
          // this.filterDropDownLists['GroupList'] = this.groupListForMultiDropDown(this.statelists,true);

        });
      })
    }
  })

}
getLocationForDistrict(){
  this.DistrictList = []
  this.distuuid = null
  let option = {
    'pType':this.constants.LOCATION_CONSTANT['STATE'],
    'cType':this.constants.LOCATION_CONSTANT['DISTRICT'],
    'puuid': (this.stateuuid != 'null' ? this.stateuuid : null)
  };
  this.activespineer = true;
  this.submitdataservice.getLocationListforUser(option).subscribe(data =>{
    this.activespineer = false;
    if(Array.isArray(data)){
      this.DistrictList = data;
    }
    // else
    //  this.fieldDropDownList['DistrictList'] = [];
   
},function(err){
    this.activespineer = false;
    if(err['error']){
      this.toastr.error(err['error']['msg'])
    }
  })
}
getLocationList(){
  let option = {};
  this.stateDropDownList = [];
  option['pType'] = this.constants.LOCATION_CONSTANT['REGION'];
  option['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
  // option['puuid'] = this.constants['COUNTRYUUID']
  // option['type'] = type;
  option["component"] = "";
  option["src"] = "";
  this.activeSpinner = true;
  this.submitdataservice.getLocationList(option).subscribe(data =>{
    if(data){
      // var data = this.submitdataService.getLocationList();
      Object.keys(data).forEach((key) => {
        data[key].forEach(list => {
          this.stateDropDownList.push(list);
        });
      });
      // this.stateDropDownList.sort(this.submitdataservice.sortStates("name"))
    }
    else
     this.stateDropDownList = [];
    this.activeSpinner = false;
},function(err){
    this.activeSpinner = false;
    if(err['error']){
      this.toastr.error(err['error']['msg'])
    }
  });
}
showdistrictdropdown(stateuuid){
  this.filterdistrict = stateuuid;
  if(stateuuid){
    this.showdistdrop = true;
  } else{
    this.showdistdrop = false;
  }
  if(this.showdistdrop){
    this.getdistrictslist();
  }
}
getdistrictslist(){
  this.DistrictList = []
  this.distuuid = "null"
  let option = {
    'pType':this.constants.LOCATION_CONSTANT['STATE'],
    'cType':this.constants.LOCATION_CONSTANT['DISTRICT'],
    'puuid': this.filterdistrict
  };
  this.activespineer = true;
  this.submitdataservice.getLocationListforUser(option).subscribe(data =>{
    this.activespineer = false;
    if(Array.isArray(data)){
      this.DistrictList = data;
      this.DistrictList.sort((a, b) => (a.name > b.name) ? 1 : -1);
    }
    // else
    //  this.fieldDropDownList['DistrictList'] = [];
   
},function(err){
    this.activespineer = false;
    if(err['error']){
      this.toastr.error(err['error']['msg'])
    }
  })
}
typechanged(){
  if(this.datasubmit == 'statewise'){
   this.districtflag = false;
  } else  {
    this.districtflag = true;
  }
}
getLocationListREgion(){  
  let option = {};
  option['pType'] = this.constants.LOCATION_CONSTANT['COUNTRY'];
  option['cType'] = this.constants.LOCATION_CONSTANT['REGION'];
  option["component"] = "";
  option["src"] = "";
  this.submitdataservice.getLocationList(option).subscribe(data =>{
    if(data){
      let grouparray = [];
      Object.keys(data).forEach((key) => {
        data[key].forEach(list => {
          grouparray.push(list)
          this.filterDropDownList['GroupList'] = this.groupListForMultiDropDown(grouparray,true);
        });
      });
    }
    else
     this.filterDropDownList['GroupList'] = [];
},function(err){
    this.activeSpinner = false;
    if(err['error']){
      this.toastr.error(err['error']['msg'])
    }
  });
}
getlocationforStateFilter(filterstate){
   this.filterDropDownList['Statedropdown'] = [];
  this.statearrays = [];
  this.statefunction = false;
  this.groupselected = filterstate;
  this.selectedstate = undefined;
  const option ={};
  option['pType'] = this.constants.LOCATION_CONSTANT['REGION'];
  option['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
  option["component"] = "";
  option["src"] = "";
  this.submitdataservice.getLocationList(option).subscribe(data =>{
    if(data){
      Object.keys(data).forEach((key) => {
        if(key == filterstate){
          data[key].forEach(element => {
            this.filterDropDownList['Statedropdown'].push(element);

          });
        }

      });
      
    }
},function(err){
    this.activeSpinner = false;
    if(err['error']){
      this.toastr.error(err['error']['msg'])
    }
  });
  this.statefunction = true;
}
groupListForMultiDropDown(data:any,issort:boolean): any{
  let result = [];
    for(let i = 0; i < data.length; i++){
      if(!data[i]) continue;
      let item = {};
      item['item_id'] = data[i]['uuid'];//id++;
      item['item_text'] = data[i]['name'];
      result.push(item);
    }
    if(issort)
     result.sort((a, b) => (a.item_text > b.item_text) ? 1 : -1);

  return result;
}
 
  checkallset(checkall){
    Object.keys(this.tabledata).forEach(id=>{
        this.tabledata[id]['ischecked'] = checkall ? true : false;
    });
  }
  getdistuuid(selectedistrict){
    this.selectedId = selectedistrict;
  }
  getTabledata(){
    this.checkall = false;
    this.activeSpinner = true;
    let params = {};
      params['component'] = 1,
      params['view'] = "admin",
      params['ay'] = this.triggercomputedlist['ay'];
      params['subTp'] = this.triggercomputedlist['montharray']
      params['cType'] =  this.constants.LOCATION_CONSTANT['DISTRICT'];
      // params['parentUUID'] = this.selectedstate ? this.selectedstate : this.region
      params['pType'] = this.constants.LOCATION_CONSTANT['STATE'];
      params["lu"] = this.selectedId;
    this.submitdataservice.forecetriggerlocationlist(params).subscribe(data => {
      this.tabledata = data;
      this.activeSpinner = false;
      });
  }

  approveOrrejectclick(action){
    let entityList = this.formatdataforbackend();
    if(entityList.length > 0){
      this.activeSpinner = true;
      let postdata = {};
      postdata = {
        "pType": "REGION",
        "cType": "STATE",
        "component": 1,
        "ay": this.assessmentYear,
        "parentUUID": this.selectedstate ? this.selectedstate : this.region
    }
      postdata['cList'] = entityList;
      this.submitdataservice.triggercomputations(postdata).subscribe(data =>{
        if(data['status']){
          this.toastr.success('Approved '+(entityList.length)+ ' records successfully');
          this.getTabledata();
        }  else {
          this.toastr.error("Error while approving record's")
        }
        this.activeSpinner = false;
      });
    } else {
      this.toastr.error('Please select atleast one record')
    }
  }
  formatdataforbackend(){
    
    let array = [];
    Object.keys(this.tabledata).forEach(id=>{
        if(this.tabledata[id].ischecked){
          array.push(id);
        }
    })
    return array;
  }

}
